import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f82feb1a"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  class: "card-btn"
};
const _hoisted_5 = {
  class: "header-label"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "sort-caret ascending"
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "sort-caret descending"
}, null, -1));
const _hoisted_10 = [_hoisted_8, _hoisted_9];
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = {
  key: 2,
  class: "pagination"
};
const _hoisted_14 = {
  class: "danger"
};
const _hoisted_15 = ["innerHTML"];
const _hoisted_16 = {
  key: 0
};
const _hoisted_17 = ["innerHTML"];
const _hoisted_18 = ["onUpdate:modelValue"];
const _hoisted_19 = {
  key: 0,
  class: "el-upload-list el-upload-list--picture-card"
};
const _hoisted_20 = {
  class: "file-icon"
};
const _hoisted_21 = ["href"];
const _hoisted_22 = {
  key: 0
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-file-earmark-pdf"
}, null, -1));
const _hoisted_24 = [_hoisted_23];
const _hoisted_25 = {
  key: 1
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-file-earmark-text"
}, null, -1));
const _hoisted_27 = [_hoisted_26];
const _hoisted_28 = {
  key: 2
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-file-earmark-word"
}, null, -1));
const _hoisted_30 = [_hoisted_29];
const _hoisted_31 = {
  key: 3
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-file-earmark-zip"
}, null, -1));
const _hoisted_33 = [_hoisted_32];
const _hoisted_34 = {
  key: 4
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-file-earmark-spreadsheet"
}, null, -1));
const _hoisted_36 = [_hoisted_35];
const _hoisted_37 = ["src", "alt"];
const _hoisted_38 = {
  key: 6
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-file-earmark"
}, null, -1));
const _hoisted_40 = [_hoisted_39];
const _hoisted_41 = ["onClick"];
const _hoisted_42 = {
  class: "detail-table"
};
const _hoisted_43 = {
  valign: "top",
  class: "detail-content"
};
const _hoisted_44 = ["innerHTML"];
const _hoisted_45 = {
  style: {
    "text-align": "center"
  }
};
import Service from './Service';
import { toRefs } from "vue";
import { defineComponent } from 'vue';
//引入element-plus图标
import { Download, Upload, Grid, Refresh as IconRefresh, QuestionFilled, Plus, Tickets, More, Menu as IconMenu } from '@element-plus/icons-vue';
import { ElCard } from 'element-plus';
//引入高亮插件
import 'highlight.js/styles/github-dark.css';
import 'highlight.js/lib/common';
import hljsVuePlugin from "@highlightjs/vue-plugin";
const __default__ = defineComponent({
  name: 'vuecmf-table',
  components: {
    ElCard,
    Download,
    Upload,
    Grid,
    IconRefresh,
    QuestionFilled,
    Plus,
    Tickets,
    More,
    IconMenu,
    highlightjs: hljsVuePlugin.component
  }
});
//异常错误提示回调处理函数
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    //加载列表数据的后端API链接
    server: {
      type: String,
      default: ''
    },
    //文件上传后端API地址
    upload_server: {
      type: String,
      default: ''
    },
    //保存单条数据
    save_server: {
      type: String,
      default: ''
    },
    //导入数据的后端API链接
    import_server: {
      type: String,
      default: ''
    },
    //删除行数据的后端API链接
    del_server: {
      type: String,
      default: ''
    },
    //后端需要的token信息
    token: {
      type: String,
      default: ''
    },
    //当前页码的参数名
    page: {
      type: String,
      default: 'page'
    },
    //每页显示条数
    limit: {
      type: Number,
      default: 20
    },
    //列表表格高度
    height: {
      type: String,
      default: '300px'
    },
    //列表中的按钮及表单样式大小 large, default, small
    size: {
      type: String,
      default: 'default',
      validator: function (value) {
        return ['default', 'large', 'small'].indexOf(value) !== -1;
      }
    },
    //操作列的宽度
    operate_width: {
      type: Number,
      default: 0
    },
    //是否显示行详情按钮
    detail_btn_visible: {
      type: Function,
      default: select_row => false
    },
    //是否显示新增按钮
    add_btn_visible: {
      type: Boolean,
      default: false
    },
    //是否显示行编辑按钮
    edit_btn_visible: {
      type: Function,
      default: select_row => false
    },
    //是否显示行删除按钮
    del_btn_visible: {
      type: Function,
      default: select_row => false
    },
    //是否显示行选择复选框
    checkbox: {
      type: Boolean,
      default: false
    },
    //是否显示行展开功能
    expand: {
      type: Boolean,
      default: false
    },
    //行是否可选回调函数
    selectable: {
      type: Function,
      default: () => true
    },
    //表单加载前的回调函数
    load_form: {
      type: Function,
      default: (tableService, select_row) => Promise.resolve(true)
    },
    //树形数据唯一键字段，列表数据为树形时（即包含 children 字段时）此项必须设置
    row_key: {
      type: String,
      default: ''
    },
    //列表数据为树形时（即包含 children 字段时）是否全部展开
    default_expand_all: {
      type: Boolean,
      default: true
    },
    //导出的文件名称
    export_file_name: {
      type: String,
      default: new Date().valueOf().toString()
    },
    //是否展开行操作
    expand_action: {
      type: Boolean,
      default: true
    },
    //表单弹窗宽度
    form_dialog_width: {
      type: String,
      default: '50%'
    },
    //日期控件显示格式, 如 2023-02-18
    date_format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    //日期控件保存的值格式, 如 2023-02-18
    date_value_format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    //日期时间控件显示格式, 如 2023-02-18 15:24:32
    datetime_format: {
      type: String,
      default: 'YYYY-MM-DD HH:mm:ss'
    },
    //日期时间控件保存的值格式, 如 2023-02-18 15:24:32
    datetime_value_format: {
      type: String,
      default: 'YYYY-MM-DD HH:mm:ss'
    },
    //列表展示方式
    show_type: {
      type: String,
      default: 'table' //table, card
    },

    //上传动作配置
    upload_action: {
      type: Function,
      default: null
    }
  },
  emits: ['exception', 'beforeLoadTable', 'afterLoadTable', 'beforeLoadData', 'afterLoadData'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    //获取父组件传入的信息
    const {
      limit,
      server,
      page,
      token,
      export_file_name,
      import_server,
      save_server,
      del_server,
      upload_server,
      load_form,
      row_key,
      show_type
    } = toRefs(props);
    //实例化服务类
    const service = new Service({
      limit: limit,
      server: server,
      page: page,
      token: token,
      export_file_name: export_file_name,
      import_server: import_server,
      save_server: save_server,
      del_server: del_server,
      upload_server: upload_server,
      load_form: load_form,
      row_key: row_key
    }, emit);
    //获取配置信息
    const {
      check_column_list,
      //列显示
      detail_dlg,
      //是否显示详情窗口
      detail_data,
      //详情内容
      vuecmf_table_ref,
      //table ref
      filter_form,
      //筛选表单
      keywords,
      // 关键字搜索
      field_options,
      //字段选项信息
      form_info,
      //字段表单信息
      relation_info,
      //字段关联信息
      form_rules,
      //表单验证配置
      form_label_width,
      //表单标签名称宽度
      //分页设置
      page_layout,
      //分页显示格式
      current_page,
      //当前页码
      page_size,
      //每页显示条数
      total,
      //列表总记录数
      //列数据相关
      table_data,
      //列表数据
      columns,
      //列头字段信息
      select_rows,
      //已选择的所有行数据
      current_select_row,
      //当前选择的一行数据
      data_show_type //列表展示方式
    } = service.getConfig('table_config');
    const {
      form_title,
      //表单标题
      edit_form_ref,
      //编辑表单ref
      edit_dlg,
      //编辑表单对话框
      import_dlg,
      //是否显示导入对话框
      import_data_form,
      //导入表单ref
      import_file_form,
      //file表单ref
      parse_data_tips,
      //解析数据时提示
      import_file_name,
      //当前导入文件名
      import_file_error,
      //导入异常提示语句
      is_import_disabled,
      //开始按钮是否禁用
      import_percentage,
      //导入进度百分比
      upload_api_url,
      //上传文件API
      changeEvent //表单中的组件change事件回调函数
    } = service.getConfig('import_config');
    const {
      show_download_dlg,
      //下载进度提示框的显示与隐藏
      percentage,
      //下载进度
      download_error //下载错误提示
    } = service.getConfig('export_config');
    data_show_type.value = show_type?.value;
    //事件方法
    const search = service.search; //搜索
    const toggleColumn = service.toggleColumn; //显示或隐藏列
    const sort = service.sort; //排序
    const handleSizeChange = service.handleSizeChange; //修改每页显示条数
    const handleCurrentChange = service.handleCurrentChange; //切换当前页码
    const formatter = service.formatter; //格式化字段显示
    const downloadExport = service.downloadExport; //导出文件
    const downloadTemplate = service.downloadTemplate; //下载导入模板文件
    const triggerUpload = service.triggerUpload; //触发上传
    const importExcel = service.importExcel; //读取文件并解析数据
    const startImportData = service.startImportData; //开始上传
    const currentSelect = service.currentSelect; //当前选择行事件
    const getSelectRows = service.getSelectRows; //获取所有选择的数据
    const detailRow = service.detailRow; //显示行详情内容
    const addRow = service.addRow; //添加一行数据
    const editRow = service.editRow; //显示行编辑表单
    const delRow = service.delRow; //删除行数据
    const saveEditRow = service.saveEditRow; //保存行编辑数据
    const previewFile = service.previewFile; //预览文件
    const uploadSuccess = service.uploadSuccess; //上传文件成功
    const fileRemove = service.fileRemove; //文件移除
    const getEditorContent = service.getEditorContent; //获取编辑器内容
    const setUploadRef = service.setUploadRef; //设置文件上传ref
    const changeShowType = service.changeShowType; //改变列表展示方式
    const copyClipboard = service.copyClipboard; //复制内容到剪贴板
    const showDownloadDlg = () => show_download_dlg.value = false;
    const showImportDlg = () => import_dlg.value = false;
    const showEditDlg = () => edit_dlg.value = false;
    const showDetailDlg = () => detail_dlg.value = false;
    service.mounted();
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_progress = _resolveComponent("el-progress");
      const _component_vuecmf_dialog = _resolveComponent("vuecmf-dialog");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_vuecmf_editor = _resolveComponent("vuecmf-editor");
      const _component_el_color_picker = _resolveComponent("el-color-picker");
      const _component_el_form = _resolveComponent("el-form");
      const _component_highlightjs = _resolveComponent("highlightjs");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_row, {
        gutter: 0
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          xs: 24,
          sm: 8,
          md: 10,
          lg: 12,
          xl: 12,
          class: "btn-group"
        }, {
          default: _withCtx(() => [__props.add_btn_visible ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            size: __props.size,
            type: "primary",
            onClick: _withModifiers(_unref(addRow), ["prevent"])
          }, {
            default: _withCtx(() => [_createTextVNode("新增")]),
            _: 1
          }, 8, ["size", "onClick"])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "headerAction", {
            selectRows: _unref(select_rows)
          })]),
          _: 3
        }), _createVNode(_component_el_col, {
          xs: 24,
          sm: 16,
          md: 14,
          lg: 12,
          xl: 12,
          class: "table-tools"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            justify: "end"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              size: __props.size,
              placeholder: "请输入内容",
              modelValue: _unref(keywords),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(keywords) ? keywords.value = $event : null),
              onChange: _unref(search),
              clearable: ""
            }, null, 8, ["size", "modelValue", "onChange"]), _createVNode(_component_el_button, {
              type: "default",
              size: __props.size,
              title: "刷新",
              onClick: _unref(search)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(IconRefresh))]),
                _: 1
              })]),
              _: 1
            }, 8, ["size", "onClick"]), _createVNode(_component_el_button, {
              type: "default",
              size: __props.size,
              title: "列表显示方式",
              onClick: _unref(changeShowType)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_unref(data_show_type) === 'card' ? (_openBlock(), _createBlock(_unref(Tickets), {
                  key: 0
                })) : (_openBlock(), _createBlock(_unref(IconMenu), {
                  key: 1
                }))]),
                _: 1
              })]),
              _: 1
            }, 8, ["size", "onClick"]), _createVNode(_component_el_dropdown, {
              trigger: "click"
            }, {
              dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
                  modelValue: _unref(check_column_list),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(check_column_list) ? check_column_list.value = $event : null),
                  class: "dropdown-content",
                  onChange: _unref(toggleColumn)
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columns), (item, index) => {
                    return _openBlock(), _createBlock(_component_el_checkbox, {
                      key: index,
                      label: item.label
                    }, {
                      default: _withCtx(() => [_createElementVNode("span", {
                        innerHTML: item.label
                      }, null, 8, _hoisted_1)]),
                      _: 2
                    }, 1032, ["label"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue", "onChange"])]),
                _: 1
              })]),
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "default",
                size: __props.size,
                title: "列"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_unref(Grid))]),
                  _: 1
                })]),
                _: 1
              }, 8, ["size"])]),
              _: 1
            }), _unref(import_server) != '' ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "default",
              size: __props.size,
              title: "导入",
              onClick: _cache[2] || (_cache[2] = $event => import_dlg.value = true)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(Upload))]),
                _: 1
              })]),
              _: 1
            }, 8, ["size"])) : _createCommentVNode("", true), _createVNode(_component_el_dropdown, {
              trigger: "click",
              onCommand: _unref(downloadExport)
            }, {
              dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                  command: "xlsx"
                }, {
                  default: _withCtx(() => [_createTextVNode("XLSX工作表")]),
                  _: 1
                }), _createVNode(_component_el_dropdown_item, {
                  command: "csv"
                }, {
                  default: _withCtx(() => [_createTextVNode("CSV文档")]),
                  _: 1
                }), _createVNode(_component_el_dropdown_item, {
                  command: "txt"
                }, {
                  default: _withCtx(() => [_createTextVNode("TXT文本文档")]),
                  _: 1
                }), _createVNode(_component_el_dropdown_item, {
                  command: "xml"
                }, {
                  default: _withCtx(() => [_createTextVNode("XML文档")]),
                  _: 1
                })]),
                _: 1
              })]),
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "default",
                size: __props.size,
                title: "导出"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_unref(Download))]),
                  _: 1
                })]),
                _: 1
              }, 8, ["size"])]),
              _: 1
            }, 8, ["onCommand"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 3
      }), _unref(data_show_type) === 'card' ? (_openBlock(), _createBlock(_component_el_row, {
        key: 0,
        gutter: 10
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(table_data), (item, index) => {
          return _openBlock(), _createBlock(_component_el_col, {
            key: 'card_' + index,
            xs: 12,
            sm: 8,
            md: 6,
            lg: 4,
            xl: 3,
            style: {
              "padding": "5px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElCard), {
              "body-style": {
                padding: '10px'
              },
              shadow: "hover"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columns), (field, idx) => {
                return _openBlock(), _createElementBlock(_Fragment, {
                  key: 'card_container_' + idx
                }, [field.show ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createTextVNode(_toDisplayString(field.label) + " : ", 1), _createElementVNode("span", {
                  innerHTML: _unref(formatter)(field.field_id, item[field.prop])
                }, null, 8, _hoisted_3)])) : _createCommentVNode("", true)], 64);
              }), 128)), _createElementVNode("div", _hoisted_4, [__props.expand_action ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [__props.detail_btn_visible(item) ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                size: __props.size,
                type: "primary",
                onClick: _withModifiers($event => _unref(detailRow)(item), ["prevent"])
              }, {
                default: _withCtx(() => [_createTextVNode("详情")]),
                _: 2
              }, 1032, ["size", "onClick"])) : _createCommentVNode("", true), __props.edit_btn_visible(item) ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                size: __props.size,
                type: "success",
                onClick: _withModifiers($event => _unref(editRow)(item), ["prevent"])
              }, {
                default: _withCtx(() => [_createTextVNode("编辑")]),
                _: 2
              }, 1032, ["size", "onClick"])) : _createCommentVNode("", true), __props.del_btn_visible(item) ? (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                size: __props.size,
                type: "danger",
                onClick: _withModifiers($event => _unref(delRow)(item), ["prevent"])
              }, {
                default: _withCtx(() => [_createTextVNode("删除")]),
                _: 2
              }, 1032, ["size", "onClick"])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "rowAction", {
                row: item,
                index: index,
                service: _unref(service)
              })], 64)) : (_openBlock(), _createBlock(_component_el_dropdown, {
                key: 1,
                size: __props.size
              }, {
                dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [__props.detail_btn_visible(item) ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: 0,
                    onClick: _withModifiers($event => _unref(detailRow)(item), ["prevent"])
                  }, {
                    default: _withCtx(() => [_createTextVNode("详情")]),
                    _: 2
                  }, 1032, ["onClick"])) : _createCommentVNode("", true), __props.edit_btn_visible(item) ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: 1,
                    onClick: _withModifiers($event => _unref(editRow)(item), ["prevent"])
                  }, {
                    default: _withCtx(() => [_createTextVNode("编辑")]),
                    _: 2
                  }, 1032, ["onClick"])) : _createCommentVNode("", true), __props.del_btn_visible(item) ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: 2,
                    onClick: _withModifiers($event => _unref(delRow)(item), ["prevent"])
                  }, {
                    default: _withCtx(() => [_createTextVNode("删除")]),
                    _: 2
                  }, 1032, ["onClick"])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "rowAction", {
                    row: item,
                    index: index,
                    service: _unref(service)
                  })]),
                  _: 2
                }, 1024)]),
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  link: "",
                  size: __props.size,
                  title: "操作"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_unref(More))]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["size"])]),
                _: 2
              }, 1032, ["size"]))])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 3
      })) : (_openBlock(), _createBlock(_component_el_table, {
        key: 1,
        ref_key: "vuecmf_table_ref",
        ref: vuecmf_table_ref,
        data: _unref(table_data),
        border: "",
        style: {
          "width": "100%"
        },
        size: __props.size,
        stripe: true,
        height: __props.height,
        onSelect: _unref(currentSelect),
        onSelectionChange: _unref(getSelectRows),
        "row-key": _unref(row_key),
        "default-expand-all": __props.default_expand_all
      }, {
        default: _withCtx(() => [__props.checkbox ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 0,
          fixed: "",
          type: "selection",
          selectable: __props.selectable,
          width: "50"
        }, null, 8, ["selectable"])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columns), (item, index) => {
          return _openBlock(), _createElementBlock(_Fragment, null, [item.show ? (_openBlock(), _createBlock(_component_el_table_column, {
            prop: item.prop,
            label: item.label,
            sortable: false,
            fixed: item.fixed,
            "min-width": item.width,
            key: index,
            "class-name": item.sort
          }, {
            header: _withCtx(() => [_createElementVNode("span", _hoisted_5, _toDisplayString(item.label), 1), item.tooltip ? (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 0,
              placement: "bottom",
              effect: "dark"
            }, {
              content: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("span", {
                innerHTML: item.tooltip
              }, null, 8, _hoisted_6)])]),
              default: _withCtx(() => [_createVNode(_component_el_icon, {
                size: "15"
              }, {
                default: _withCtx(() => [_createVNode(_unref(QuestionFilled))]),
                _: 1
              })]),
              _: 2
            }, 1024)) : _createCommentVNode("", true), _createElementVNode("div", null, [item.filter ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_unref(field_options) != null && typeof _unref(field_options)[item.field_id] == 'object' ? (_openBlock(), _createBlock(_component_el_select, {
              key: 0,
              modelValue: _unref(filter_form)[item.prop],
              "onUpdate:modelValue": $event => _unref(filter_form)[item.prop] = $event,
              onChange: _unref(search),
              multiple: "",
              "collapse-tags": "",
              placeholder: "请选择",
              size: __props.size
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(field_options)[item.field_id], (option_val, option_key) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: option_key,
                  label: option_val.label,
                  value: option_val.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "size"])) : _unref(relation_info) != null && typeof _unref(relation_info).options == 'object' && typeof _unref(relation_info).options[item.field_id] == 'object' ? (_openBlock(), _createBlock(_component_el_select, {
              key: 1,
              modelValue: _unref(filter_form)[item.prop],
              "onUpdate:modelValue": $event => _unref(filter_form)[item.prop] = $event,
              onChange: _unref(search),
              multiple: "",
              "collapse-tags": "",
              placeholder: "请选择",
              size: __props.size
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(relation_info).full_options[item.field_id], (option_val, option_key) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: option_key,
                  label: option_val.label,
                  value: option_val.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "size"])) : ['date', 'datetime', 'timestamp'].indexOf(item.type) !== -1 ? (_openBlock(), _createBlock(_component_el_date_picker, {
              key: 2,
              onChange: _unref(search),
              size: __props.size,
              format: __props.date_format,
              "value-format": __props.date_value_format,
              modelValue: _unref(filter_form)[item.prop],
              "onUpdate:modelValue": $event => _unref(filter_form)[item.prop] = $event,
              type: "daterange",
              "range-separator": "至",
              "start-placeholder": "开始时间",
              "end-placeholder": "结束时间"
            }, null, 8, ["onChange", "size", "format", "value-format", "modelValue", "onUpdate:modelValue"])) : (_openBlock(), _createBlock(_component_el_input, {
              key: 3,
              onChange: _unref(search),
              modelValue: _unref(filter_form)[item.prop],
              "onUpdate:modelValue": $event => _unref(filter_form)[item.prop] = $event,
              size: __props.size,
              clearable: "",
              placeholder: "输入关键字搜索"
            }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue", "size"]))], 64)) : _createCommentVNode("", true)]), _createElementVNode("span", {
              class: "caret-wrapper",
              onClick: $event => _unref(sort)(item)
            }, _hoisted_10, 8, _hoisted_7)]),
            default: _withCtx(scope => [_renderSlot(_ctx.$slots, "formatRow", {
              row: scope.row,
              field: item.prop
            }, () => [_createElementVNode("span", {
              innerHTML: _unref(formatter)(item.field_id, scope.row[item.prop])
            }, null, 8, _hoisted_11)])]),
            _: 2
          }, 1032, ["prop", "label", "fixed", "min-width", "class-name"])) : _createCommentVNode("", true)], 64);
        }), 256)), __props.operate_width > 0 ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 1,
          fixed: "right",
          label: "操作",
          "min-width": __props.operate_width
        }, {
          default: _withCtx(scope => [__props.expand_action ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [__props.detail_btn_visible(scope.row) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            size: __props.size,
            type: "primary",
            onClick: _withModifiers($event => _unref(detailRow)(scope.row), ["prevent"])
          }, {
            default: _withCtx(() => [_createTextVNode("详情")]),
            _: 2
          }, 1032, ["size", "onClick"])) : _createCommentVNode("", true), __props.edit_btn_visible(scope.row) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            size: __props.size,
            type: "success",
            onClick: _withModifiers($event => _unref(editRow)(scope.row), ["prevent"])
          }, {
            default: _withCtx(() => [_createTextVNode("编辑")]),
            _: 2
          }, 1032, ["size", "onClick"])) : _createCommentVNode("", true), __props.del_btn_visible(scope.row) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            size: __props.size,
            type: "danger",
            onClick: _withModifiers($event => _unref(delRow)(scope.row), ["prevent"])
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 2
          }, 1032, ["size", "onClick"])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "rowAction", {
            row: scope.row,
            index: scope.$index,
            service: _unref(service)
          })], 64)) : (_openBlock(), _createBlock(_component_el_dropdown, {
            key: 1,
            size: __props.size
          }, {
            dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [__props.detail_btn_visible(scope.row) ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                key: 0,
                onClick: _withModifiers($event => _unref(detailRow)(scope.row), ["prevent"])
              }, {
                default: _withCtx(() => [_createTextVNode("详情")]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), __props.edit_btn_visible(scope.row) ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                key: 1,
                onClick: _withModifiers($event => _unref(editRow)(scope.row), ["prevent"])
              }, {
                default: _withCtx(() => [_createTextVNode("编辑")]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), __props.del_btn_visible(scope.row) ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                key: 2,
                onClick: _withModifiers($event => _unref(delRow)(scope.row), ["prevent"])
              }, {
                default: _withCtx(() => [_createTextVNode("删除")]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "rowAction", {
                row: scope.row,
                index: scope.$index,
                service: _unref(service)
              })]),
              _: 2
            }, 1024)]),
            default: _withCtx(() => [_createVNode(_component_el_button, {
              link: "",
              size: __props.size,
              title: "操作"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(More))]),
                _: 1
              })]),
              _: 1
            }, 8, ["size"])]),
            _: 2
          }, 1032, ["size"]))]),
          _: 3
        }, 8, ["min-width"])) : _createCommentVNode("", true), __props.expand ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 2,
          type: "expand",
          fixed: "left"
        }, {
          default: _withCtx(props => [_renderSlot(_ctx.$slots, "rowExpand", {
            row: props.row,
            index: props.$index
          }, () => [props.row.expand_data != undefined && props.row.expand_data.table_list != undefined ? (_openBlock(), _createBlock(_component_el_table, {
            key: 0,
            border: "",
            data: props.row.expand_data.table_list,
            size: __props.size,
            stripe: true
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.expand_data.table_fields, (item, index) => {
              return _openBlock(), _createBlock(_component_el_table_column, {
                prop: item.prop,
                label: item.label,
                width: item.width,
                key: index
              }, {
                default: _withCtx(expand_scope => [_createElementVNode("span", {
                  innerHTML: expand_scope.row[item.prop]
                }, null, 8, _hoisted_12)]),
                _: 2
              }, 1032, ["prop", "label", "width"]);
            }), 128))]),
            _: 2
          }, 1032, ["data", "size"])) : _createCommentVNode("", true)])]),
          _: 3
        })) : _createCommentVNode("", true)]),
        _: 3
      }, 8, ["data", "size", "height", "onSelect", "onSelectionChange", "row-key", "default-expand-all"])), typeof _unref(row_key) == 'undefined' || _unref(row_key) === '' || _unref(row_key) == null ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_el_pagination, {
        onSizeChange: _unref(handleSizeChange),
        onCurrentChange: _unref(handleCurrentChange),
        "current-page": _unref(current_page),
        "page-sizes": [5, 20, 30, 40, 50, 100, 200, 300, 500, 1000],
        "page-size": _unref(page_size),
        layout: _unref(page_layout),
        "pager-count": 5,
        total: _unref(total)
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "layout", "total"])])) : _createCommentVNode("", true), _createVNode(_component_vuecmf_dialog, {
        title: "正在下载数据，请稍后...",
        model_value: _unref(show_download_dlg),
        width: __props.form_dialog_width,
        close_on_click_modal: false,
        close_on_press_escape: false,
        onUpdateVisible: showDownloadDlg
      }, {
        content: _withCtx(() => [_createElementVNode("span", _hoisted_14, _toDisplayString(_unref(download_error)), 1), _createVNode(_component_el_progress, {
          "text-inside": true,
          "stroke-width": 18,
          percentage: _unref(percentage)
        }, null, 8, ["percentage"])]),
        _: 1
      }, 8, ["model_value", "width"]), _createVNode(_component_vuecmf_dialog, {
        model_value: _unref(import_dlg),
        title: "导入",
        width: __props.form_dialog_width,
        custom_class: "import-dlg",
        onClose: _unref(search),
        onUpdateVisible: showImportDlg
      }, {
        content: _withCtx(() => [_createVNode(_component_el_row, {
          justify: "space-between"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12,
            class: "import-form"
          }, {
            default: _withCtx(() => [_createElementVNode("form", {
              ref_key: "import_data_form",
              ref: import_data_form
            }, [_createElementVNode("input", {
              type: "file",
              ref_key: "import_file_form",
              ref: import_file_form,
              class: "file-form",
              onChange: _cache[3] || (_cache[3] =
              //@ts-ignore
              (...args) => _unref(importExcel) && _unref(importExcel)(...args)),
              accept: ".xlsx, .xls"
            }, null, 544), _createVNode(_component_el_button, {
              type: "primary",
              onClick: _unref(triggerUpload),
              size: __props.size
            }, {
              default: _withCtx(() => [_createTextVNode("选择文件")]),
              _: 1
            }, 8, ["onClick", "size"])], 512)]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12,
            class: "download-tpl-btn"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "success",
              onClick: _unref(downloadTemplate),
              size: __props.size
            }, {
              default: _withCtx(() => [_createTextVNode("下载模板")]),
              _: 1
            }, 8, ["onClick", "size"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_unref(import_file_name) !== '' ? (_openBlock(), _createBlock(_component_el_col, {
            key: 0,
            class: "upload-tips"
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, "当前选择文件: " + _toDisplayString(_unref(import_file_name)), 1), _createElementVNode("div", {
              innerHTML: _unref(parse_data_tips)
            }, null, 8, _hoisted_15), _unref(import_file_error) !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", {
              class: "danger",
              innerHTML: _unref(import_file_error)
            }, null, 8, _hoisted_17)])) : _createCommentVNode("", true)]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
            class: "upload-progress"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_progress, {
              "text-inside": true,
              status: "success",
              "stroke-width": 18,
              percentage: _unref(import_percentage)
            }, null, 8, ["percentage"])]),
            _: 1
          })]),
          _: 1
        })]),
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          type: "default",
          size: __props.size,
          onClick: _cache[4] || (_cache[4] = $event => import_dlg.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("关闭")]),
          _: 1
        }, 8, ["size"]), _createVNode(_component_el_button, {
          type: "primary",
          size: __props.size,
          onClick: _unref(startImportData),
          disabled: _unref(is_import_disabled)
        }, {
          default: _withCtx(() => [_createTextVNode("开始")]),
          _: 1
        }, 8, ["size", "onClick", "disabled"])]),
        _: 1
      }, 8, ["model_value", "width", "onClose"]), _createVNode(_component_vuecmf_dialog, {
        model_value: _unref(edit_dlg),
        title: _unref(form_title),
        width: __props.form_dialog_width,
        onClose: _unref(search),
        onUpdateVisible: showEditDlg
      }, {
        content: _withCtx(() => [_createVNode(_component_el_form, {
          inline: false,
          ref_key: "edit_form_ref",
          ref: edit_form_ref,
          "status-icon": "",
          rules: _unref(form_rules),
          "label-width": _unref(form_label_width) + 'px',
          size: __props.size,
          model: _unref(current_select_row),
          class: "edit-form-inline"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form_info), (item, index) => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: index
            }, [item.type === 'date' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: item.label,
              prop: item.field_name
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: _unref(current_select_row)[item.field_name],
                "onUpdate:modelValue": $event => _unref(current_select_row)[item.field_name] = $event,
                format: __props.date_format,
                "value-format": __props.date_value_format,
                type: "date",
                placeholder: "请选择日期",
                disabled: item.is_disabled,
                clearable: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue", "format", "value-format", "disabled"])]),
              _: 2
            }, 1032, ["label", "prop"])) : item.type === 'datetime' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: item.label,
              prop: item.field_name
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: _unref(current_select_row)[item.field_name],
                "onUpdate:modelValue": $event => _unref(current_select_row)[item.field_name] = $event,
                format: __props.datetime_format,
                "value-format": __props.datetime_value_format,
                type: "datetime",
                placeholder: "请选择日期时间",
                disabled: item.is_disabled,
                clearable: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue", "format", "value-format", "disabled"])]),
              _: 2
            }, 1032, ["label", "prop"])) : item.type === 'input_number' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              label: item.label,
              prop: item.field_name
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: _unref(current_select_row)[item.field_name],
                "onUpdate:modelValue": $event => _unref(current_select_row)[item.field_name] = $event,
                disabled: item.is_disabled
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
              _: 2
            }, 1032, ["label", "prop"])) : item.type === 'hidden' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              label: item.label,
              prop: item.field_name,
              style: {
                "display": "none"
              }
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
                type: "hidden",
                "onUpdate:modelValue": $event => _unref(current_select_row)[item.field_name] = $event
              }, null, 8, _hoisted_18), [[_vModelText, _unref(current_select_row)[item.field_name]]])]),
              _: 2
            }, 1032, ["label", "prop"])) : item.type === 'textarea' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 4,
              label: item.label,
              prop: item.field_name
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(current_select_row)[item.field_name],
                "onUpdate:modelValue": $event => _unref(current_select_row)[item.field_name] = $event,
                rows: 3,
                placeholder: "请输入内容",
                type: "textarea",
                disabled: item.is_disabled
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
              _: 2
            }, 1032, ["label", "prop"])) : item.type === 'switch' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 5,
              label: item.label,
              prop: item.field_name
            }, {
              default: _withCtx(() => [_createVNode(_component_el_switch, {
                modelValue: _unref(current_select_row)[item.field_name],
                "onUpdate:modelValue": $event => _unref(current_select_row)[item.field_name] = $event,
                "active-value": "10",
                "inactive-value": "20",
                disabled: item.is_disabled
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
              _: 2
            }, 1032, ["label", "prop"])) : ['radio', 'checkbox', 'select', 'select_mul'].indexOf(item.type) !== -1 ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 6,
              label: item.label,
              prop: item.field_name
            }, {
              default: _withCtx(() => [typeof _unref(field_options)[item.field_id] != 'undefined' ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [item.type === 'radio' ? (_openBlock(), _createBlock(_component_el_radio_group, {
                key: 0,
                modelValue: _unref(current_select_row)[item.field_name],
                "onUpdate:modelValue": $event => _unref(current_select_row)[item.field_name] = $event,
                disabled: item.is_disabled
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(field_options)[item.field_id], (op_val, op_idx) => {
                  return _openBlock(), _createBlock(_component_el_radio, {
                    label: op_val.value,
                    key: op_idx
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(op_val.label), 1)]),
                    _: 2
                  }, 1032, ["label"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])) : item.type === 'checkbox' ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
                key: 1,
                modelValue: _unref(current_select_row)[item.field_name],
                "onUpdate:modelValue": $event => _unref(current_select_row)[item.field_name] = $event,
                disabled: item.is_disabled
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(field_options)[item.field_id], (op_val, op_idx) => {
                  return _openBlock(), _createBlock(_component_el_checkbox, {
                    label: op_val.value,
                    key: op_idx
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(op_val.label), 1)]),
                    _: 2
                  }, 1032, ["label"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])) : (_openBlock(), _createBlock(_component_el_select, {
                key: 2,
                teleported: false,
                modelValue: _unref(current_select_row)[item.field_name],
                "onUpdate:modelValue": $event => _unref(current_select_row)[item.field_name] = $event,
                filterable: "",
                multiple: item.type === 'select_mul',
                placeholder: "请选择",
                disabled: item.is_disabled,
                clearable: "",
                onChange: sel_val => {
                  if (typeof _unref(relation_info).linkage == 'object' && typeof _unref(relation_info).linkage[item.field_id] == 'object') _unref(changeEvent)(item.field_name, sel_val);
                }
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(field_options)[item.field_id], (op_val, op_idx) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: op_val.label,
                    value: op_val.value,
                    key: op_idx
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "multiple", "disabled", "onChange"]))], 64)) : typeof _unref(relation_info).options == 'object' && typeof _unref(relation_info).options[item.field_id] != 'undefined' ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 1
              }, [item.type === 'radio' ? (_openBlock(), _createBlock(_component_el_radio_group, {
                key: 0,
                disabled: item.is_disabled,
                modelValue: _unref(current_select_row)[item.field_name],
                "onUpdate:modelValue": $event => _unref(current_select_row)[item.field_name] = $event,
                onChange: sel_val => {
                  if (typeof _unref(relation_info).linkage == 'object' && typeof _unref(relation_info).linkage[item.field_id] == 'object') _unref(changeEvent)(item.field_name, sel_val);
                }
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(relation_info).options[item.field_id], (op_val, op_idx) => {
                  return _openBlock(), _createBlock(_component_el_radio, {
                    label: op_val.value,
                    key: op_idx
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(op_val.label), 1)]),
                    _: 2
                  }, 1032, ["label"]);
                }), 128))]),
                _: 2
              }, 1032, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"])) : item.type === 'checkbox' ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
                key: 1,
                disabled: item.is_disabled,
                modelValue: _unref(current_select_row)[item.field_name],
                "onUpdate:modelValue": $event => _unref(current_select_row)[item.field_name] = $event,
                onChange: sel_val => {
                  if (typeof _unref(relation_info).linkage == 'object' && typeof _unref(relation_info).linkage[item.field_id] == 'object') _unref(changeEvent)(item.field_name, sel_val);
                }
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(relation_info).options[item.field_id], (op_val, op_idx) => {
                  return _openBlock(), _createBlock(_component_el_checkbox, {
                    label: op_val.value,
                    key: op_idx
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(op_val.label), 1)]),
                    _: 2
                  }, 1032, ["label"]);
                }), 128))]),
                _: 2
              }, 1032, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"])) : (_openBlock(), _createBlock(_component_el_select, {
                key: 2,
                disabled: item.is_disabled,
                teleported: false,
                modelValue: _unref(current_select_row)[item.field_name],
                "onUpdate:modelValue": $event => _unref(current_select_row)[item.field_name] = $event,
                filterable: "",
                multiple: item.type === 'select_mul',
                placeholder: "请选择",
                clearable: "",
                onChange: sel_val => {
                  if (typeof _unref(relation_info).linkage == 'object' && typeof _unref(relation_info).linkage[item.field_id] == 'object') _unref(changeEvent)(item.field_name, sel_val);
                }
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(relation_info).options[item.field_id], (op_val, op_idx) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: op_val.label,
                    value: op_val.value,
                    key: op_idx
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 2
              }, 1032, ["disabled", "modelValue", "onUpdate:modelValue", "multiple", "onChange"]))], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
                key: 2
              }, [_createTextVNode(" 没有获取到相关内容 ")], 64))]),
              _: 2
            }, 1032, ["label", "prop"])) : item.type === 'upload_image' || item.type === 'upload_file' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 7,
              label: item.label,
              prop: item.field_name
            }, {
              default: _withCtx(() => [typeof __props.upload_action == 'function' ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(current_select_row)[item.field_name], (file_item, file_key) => {
                return _openBlock(), _createElementBlock("li", {
                  class: "el-upload-list__item is-ready",
                  key: file_key
                }, [_createElementVNode("div", _hoisted_20, [_createElementVNode("a", {
                  href: file_item.url,
                  target: "_blank"
                }, [file_item.url.substring(file_item.url.length - 4).toLowerCase() == '.pdf' ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24)) : file_item.url.substring(file_item.url.length - 4).toLowerCase() == '.txt' ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27)) : ['.doc', 'docx'].indexOf(file_item.url.substring(file_item.url.length - 4).toLowerCase()) != -1 ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30)) : ['.zip', '.rar'].indexOf(file_item.url.substring(file_item.url.length - 4).toLowerCase()) != -1 ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33)) : ['.xls', 'xlsx'].indexOf(file_item.url.substring(file_item.url.length - 4).toLowerCase()) != -1 ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36)) : ['.gif', '.jpg', 'jpeg', '.png', '.bmp'].indexOf(file_item.url.substring(file_item.url.length - 4).toLowerCase()) != -1 ? (_openBlock(), _createElementBlock("img", {
                  key: 5,
                  class: "el-upload-list__item-thumbnail",
                  src: file_item.url,
                  alt: file_item.name
                }, null, 8, _hoisted_37)) : (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40))], 8, _hoisted_21)])]);
              }), 128)), _createElementVNode("li", {
                class: "el-upload el-upload--picture-card",
                onClick: $event => __props.upload_action(_unref(current_select_row)[item.field_name], item)
              }, [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(Plus))]),
                _: 1
              })], 8, _hoisted_41)])) : (_openBlock(), _createBlock(_component_el_upload, {
                key: 1,
                disabled: item.is_disabled,
                ref_for: true,
                ref: el => _unref(setUploadRef)(el, item.field_name),
                headers: {
                  token: _unref(token)
                },
                data: {
                  field_name: item.field_name
                },
                action: _unref(upload_api_url),
                "on-preview": _unref(previewFile),
                "on-success": _unref(uploadSuccess),
                "on-remove": _unref(fileRemove),
                "list-type": item.type === 'upload_image' ? 'picture-card' : 'text',
                accept: item.type === 'upload_image' ? 'image/*' : '',
                multiple: "",
                "file-list": _unref(current_select_row)[item.field_name]
              }, {
                default: _withCtx(() => [item.type === 'upload_image' ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 0
                }, {
                  default: _withCtx(() => [_createVNode(_unref(Plus))]),
                  _: 1
                })) : (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  size: __props.size,
                  type: "primary"
                }, {
                  default: _withCtx(() => [_createTextVNode("上传")]),
                  _: 1
                }, 8, ["size"]))]),
                _: 2
              }, 1032, ["disabled", "headers", "data", "action", "on-preview", "on-success", "on-remove", "list-type", "accept", "file-list"]))]),
              _: 2
            }, 1032, ["label", "prop"])) : item.type === 'editor' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 8,
              label: item.label,
              prop: item.field_name
            }, {
              default: _withCtx(() => [_createVNode(_component_vuecmf_editor, {
                id: item.field_name,
                content: _unref(current_select_row)[item.field_name],
                onOnChange: _unref(getEditorContent),
                token: _unref(token),
                params: {
                  field_name: item.field_name
                },
                upload: _unref(upload_api_url),
                size: __props.size,
                upload_action: __props.upload_action
              }, null, 8, ["id", "content", "onOnChange", "token", "params", "upload", "size", "upload_action"])]),
              _: 2
            }, 1032, ["label", "prop"])) : item.type === 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 9,
              label: item.label,
              prop: item.field_name
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                disabled: item.is_disabled,
                modelValue: _unref(current_select_row)[item.field_name],
                "onUpdate:modelValue": $event => _unref(current_select_row)[item.field_name] = $event,
                type: "password",
                autocomplete: "off",
                clearable: ""
              }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])]),
              _: 2
            }, 1032, ["label", "prop"])) : item.type === 'color_picker' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 10,
              label: item.label,
              prop: item.field_name
            }, {
              default: _withCtx(() => [_createVNode(_component_el_color_picker, {
                disabled: item.is_disabled,
                modelValue: _unref(current_select_row)[item.field_name],
                "onUpdate:modelValue": $event => _unref(current_select_row)[item.field_name] = $event
              }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])]),
              _: 2
            }, 1032, ["label", "prop"])) : (_openBlock(), _createBlock(_component_el_form_item, {
              key: 11,
              label: item.label,
              prop: item.field_name
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                disabled: item.is_disabled,
                modelValue: _unref(current_select_row)[item.field_name],
                "onUpdate:modelValue": $event => _unref(current_select_row)[item.field_name] = $event,
                placeholder: item.default_value,
                clearable: ""
              }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "placeholder"])]),
              _: 2
            }, 1032, ["label", "prop"]))], 64);
          }), 128))]),
          _: 1
        }, 8, ["rules", "label-width", "size", "model"])]),
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          type: "default",
          size: __props.size,
          onClick: _cache[5] || (_cache[5] = $event => edit_dlg.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }, 8, ["size"]), _createVNode(_component_el_button, {
          type: "primary",
          size: __props.size,
          onClick: _unref(saveEditRow)
        }, {
          default: _withCtx(() => [_createTextVNode("保存")]),
          _: 1
        }, 8, ["size", "onClick"])]),
        _: 1
      }, 8, ["model_value", "title", "width", "onClose"]), _createVNode(_component_vuecmf_dialog, {
        model_value: _unref(detail_dlg),
        width: __props.form_dialog_width,
        title: "详情",
        onUpdateVisible: showDetailDlg
      }, {
        content: _withCtx(() => [_createElementVNode("table", _hoisted_42, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columns), (item, index) => {
          return _openBlock(), _createElementBlock("tr", {
            key: index
          }, [_createElementVNode("th", {
            align: "right",
            valign: "top",
            style: _normalizeStyle('min-width:' + _unref(form_label_width) + 'px')
          }, _toDisplayString(item.label) + ":", 5), _createElementVNode("td", _hoisted_43, [item['code'] != null && item['code'] === true ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_el_button, {
            type: "info",
            size: "small",
            class: "copy-btn",
            onClick: $event => _unref(copyClipboard)(_unref(formatter)(item.field_id, _unref(detail_data)[item.prop]))
          }, {
            default: _withCtx(() => [_createTextVNode("复制")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_highlightjs, {
            code: _unref(formatter)(item.field_id, _unref(detail_data)[item.prop])
          }, null, 8, ["code"])], 64)) : item.form_type === 'color_picker' ? (_openBlock(), _createBlock(_component_el_color_picker, {
            key: 1,
            "model-value": _unref(formatter)(item.field_id, _unref(detail_data)[item.prop])
          }, null, 8, ["model-value"])) : (_openBlock(), _createElementBlock("div", {
            key: 2,
            innerHTML: _unref(formatter)(item.field_id, _unref(detail_data)[item.prop])
          }, null, 8, _hoisted_44))])]);
        }), 128))])]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_45, [_createVNode(_component_el_button, {
          type: "default",
          size: __props.size,
          onClick: _cache[6] || (_cache[6] = $event => detail_dlg.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("关闭")]),
          _: 1
        }, 8, ["size"])])]),
        _: 1
      }, 8, ["model_value", "width"])], 64);
    };
  }
});